export default "__VITE_ASSET__cf9dcb2f__"